import { makeStyles } from 'tss-react/mui';

import { isLightMode } from 'pages/Landings/utils';

export default makeStyles({ name: 'SubMenu' })((theme) => {
    return {
        root: {
            display: 'flex',
            width: '100%',
            padding: 16,
            gap: 8,
            borderRadius: 24,
            border: isLightMode(theme) ? '1px solid rgba(0, 0, 0, 0.05)' : '1px solid rgba(255, 255, 255, 0.05)',
            background: isLightMode(theme) ? 'rgba(255, 255, 255, 0.75)' : 'rgba(23, 22, 27, 0.75)',
            boxSizing: 'border-box'
        },
        divider: {
            background: isLightMode(theme) ? 'rgba(0, 0, 0, 0.05)' : '#393939',
            borderColor: isLightMode(theme) ? 'rgba(0, 0, 0, 0.05)' : '#393939'
        }
    };
});
